module.exports = __webpack_public_path__ + "media/images/countrysquared/mw-9c8d1b16139c94ec194bd43c0edcb369.svg";